import { defineComponent as _defineComponent } from 'vue'
import CommonFormItems from '../components/CommonFormItems.vue'
import FileUpload from '@/components/UploadFile/index.vue'
import { computed, onBeforeMount, onUnmounted, ref, shallowRef } from 'vue'
import { UploadFileRes } from '@/api/common/common-api-type'
import { Message } from 'element-ui'
import { AsrOfflineModule } from '@/store/modules/asr-offline'
import { startOfflineAsrTaskApi } from '@/api/asr'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['set-tab'],
  setup(__props, { emit: emits }) {

const task = ref<{
  lang: 'cn' | 'eng',
  property: string,
  fileList: UploadFileRes[]
}>({
  lang: 'cn',
  property: '',
  fileList: []
})

const fileUploadRef = shallowRef<InstanceType<typeof FileUpload>>()
const hasFileUploading = computed(() => fileUploadRef.value?.hasLoading)
const hasFailUpload = computed(() => fileUploadRef.value?.hasFailUpload)
const status = computed(() => AsrOfflineModule.status)
const submitLoading = ref(false)
async function startTask() {
  // if(!task.value.property) {
  //   Message.error('请选择专业领域')
  //   return
  // }
  submitLoading.value = true
  // AsrOfflineModule.START_TASK(task.value)
  try {
    const {
      lang,
      fileList,
      property,
    } = task.value
    const fileIds = fileList.map(file => file.id)
    await startOfflineAsrTaskApi(lang, fileIds, property)
    Message.success('创建成功')
    fileUploadRef.value?.clearFiles()
    // 提交任务后跳转结果列表tab
    emits('set-tab', 'list')
  } catch (error) {
    console.log('error: ', error)
  } finally {
    submitLoading.value = false
  }
}

onBeforeMount(() => {
  const cacheTask = AsrOfflineModule.task
  if(cacheTask) {
    task.value = cacheTask
    AsrOfflineModule.AWAKEN_TASK()
  }
})

onUnmounted(() => {
  AsrOfflineModule.HIBERNATE_TASK()
})


return { __sfc: true,task, emits, fileUploadRef, hasFileUploading, hasFailUpload, status, submitLoading, startTask, CommonFormItems, FileUpload }
}

})